import { render, staticRenderFns } from "./ComparisonHeader.vue?vue&type=template&id=2dbbbd82"
import script from "./ComparisonHeader.vue?vue&type=script&lang=js"
export * from "./ComparisonHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports